import React from 'react';
import { Container } from 'react-bootstrap';
import './UploadSection.css';
import { Link } from 'react-router-dom';

function UploadSection  () {
    return (
        <div>
            <Container>
                <p className='share__materials typing-text'>"Share Your Study Materials with Fellow Students!"</p>
                <div className='para_cont'>
                        <p className='contribute'>Contribute your study resources so that everyone has access to them and can use them. a space where students can collaborate on their studies in groups.
                        </p>
                </div>
            <div class="row">
                        <div class="col">
                            <Link to='/StudyMaterialsUpload'>
                            <ul className='left__side__list'>
                                <li>
                                  <a href='' > <button className='left__side__list upload__items diagonal-hoverrr'> <div className='contenttt'> <i class="fa-solid fa-book fa"></i> <br/> Upload books/ test papers / notes </div>  </button> </a> 
                                </li>
                            </ul>
                            </Link>
                        </div>
                        
                        <div className='col'>
                            <Link to="/CollegeReviewF">
                            <ul className='left__side__list'>
                                <li>
                                   <a href='' > <button className='left__side__list upload__items diagonal-hoverrr'> <div className='contenttt'> <i className='fas fa-edit fa'></i> <br/> Share College Review </div> </button> </a>
                                </li>
                            </ul>
                            </Link>
                        </div>
                        <div className='col'>
                            <Link to="/WebsiteUrlF">
                            <ul className='left__side__list'>   
                                <li>
                                   <a href='' > <button className='left__side__list upload__items diagonal-hoverrr'>  <div className='contenttt'> <i class='far fa-sticky-note fa'></i>  <br/>
                                    Website Url
                                     </div> </button> </a>
                                </li>
                            </ul>
                            </Link>
                        </div>
                        <div class="col">
                            <Link to="/YoutubeUrlF">
                            <ul className='center__list'>
                                <li>
                                   <a href='' > <button className='left__side__list upload__items diagonal-hoverrr'>  <div className='contenttt'> <i class="fa-solid fa-share fa"></i> <br/> Share Youtube Channel Url </div> </button> </a>
                                </li>
                            </ul>
                            </Link>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <Link to="OnlineToolF">
                        <ul className='left__side__list'>
                                <li>
                                   <a href='' > <button className='left__side__list upload__items diagonal-hoverrr'>  <div className='contenttt'> <i class="fa-solid fa-share fa"></i> <br/> Share Online Tools </div> </button> </a>
                                </li>
                            </ul>
                            </Link>
                        </div>

                        <div className='col'>
                            <Link to="/SoftwareDownloadF">
                        <ul className='left__side__list'>
                                <li>
                                   <a href='' > <button className='left__side__list upload__items diagonal-hoverrr'>  <div className='contenttt'> <i class="fa-solid fa-share fa"></i> <br/> Share Software </div> </button> </a>
                                </li>
                            </ul>
                            </Link>
                        </div>
                        <div className='col'>
                        <ul className='left__side__list'>
                                <li>
                                    <button className='left__side__list upload__items diagonal-hoverrr'>  <div className='contenttt'>  Coming Soon  </div> </button> 
                                </li>
                            </ul>
                        </div>

                        <div className='col'>
                        <ul className='center__list'>
                                <li>
                                    <button className='left__side__list upload__items diagonal-hoverrr'>  <div className='contenttt'>  Coming Soon  </div> </button> 
                                </li>
                            </ul>
                        </div>
                    </div>
            </Container> <br/>
            <hr/>
            <br/>
        </div>
    );
}

export default UploadSection;
